<template>
  <div class="main">
    <img class="not_banner"
         src="../../assets/img/pay/secban.jpg" />
         <div class="centent_img">
            <img class="not_banner" src="../../assets/img/pay/seccback.png" />
            <p class="textp">请您及时<b class="strongSpan">补录</b>家人的参保信息<br>以免影响您的<b class="strongSpan">承保生效</b></p>
          </div>
          <van-button :class="[fxshow ? '' : 'hiddens']" @click="recording">补录信息</van-button>
         <div :class="[!fxshow ? '' : 'hiddens', 'centent_img']">
            <img class="not_banner" src="../../assets/img/pay/h5paysuccess.png" />
            <div class="h5Show stateP">长按识别下方二维码关注 <b>【湖南爱民保】</b>公众号进入 <b>【个人中心】</b>及时补录您及家人的参保信息</div>
            <dl class="wxqrcode">
              <dt><img src="../../assets/img/pay/wxlecheng.png" />
                <p>扫码关注公众号查保单</p>
              </dt>
              <dd><img src="../../assets/img/pay/wxcess.png" />
                <p>扫码添加专属顾问咨询</p>
              </dd>
            </dl>
         </div>
  </div>
</template>

<script>
// import { getDeviceInfo } from '@/util/tools'
import { SetLeChengShare } from '@/util/set-wx-share'
export default {
  name: 'BuySuccess',
  components: {},
  filters: {},
  mixins: [],
  props: {},
  data() {
    return {
      payType: '',
      fxshow: false,
      show: false,
      platInfo: {},
      insuranceId: '',
      // eslint-disable-next-line no-undef
      orderInfo: {}
    }
  },
  computed: {},
  watch: {
    $route: {
      handler: function (newVal, oldVal) {
        if (newVal.fullPath !== oldVal.fllPath) {
          this.initPage()
        }
      }
    }
  },
  created() {
  },
  mounted() {
    this.insuranceId = this.$route.query.insuranceId
    this.payType = this.$route.query.payType
    if (this.payType === 'alipayAcc') { // 支付方式为支付宝时做埋点
    // eslint-disable-next-line no-undef
    __bl.api({api:"成功投保",success:true,c1:"taSR_YL", time:0})
      // eslint-disable-next-line no-undef
      // __bl.api({api:"成功投保",success:true,c1:"taSR_YL"})
    }
    this.platInfo = this.getDeviceInfo()
    console.log('this.platInfo.env', this.platInfo.env, this.platInfo.env === 'wechat')
    if (this.platInfo.env === 'wechat') {
      console.log('微信环境，可显示补录按钮', this.platInfo.env, this.platInfo.env === 'wechat')
      this.fxshow = true
    } else {
      console.log('非微信环境，不显示补全按钮', this.platInfo.env, this.platInfo.env === 'wechat')
      this.fxshow = false
    }
    this.initPage()
  },
  destroyed() {
    sessionStorage.removeItem('buySuccess')
  },
  methods: {
    getDeviceInfo() {
      let ua = window.navigator.userAgent
      let info = {}
      if (/iphone|ipad|ipod|ios/i.test(ua)) {
        info.device = 'ios'
      } else if (/android/i.test(ua)) {
        info.device = 'android'
      } else {
        info.device = 'android'
      }

      if (/micromessenger/i.test(ua)) {
        info.env = 'wechat'
      } else if (/weibo/i.test(ua)) {
        info.env = 'weibo'
      } else if (/mqqbrowser/i.test(ua)) {
        info.env = 'mqqbrowser'
      } else if (/qq/i.test(ua)) {
        info.env = 'qq'
      } else {
        info.env = 'other'
      }
      return info
    },
    recording() {
      this.$router.push({
        path: '/policy-detail/' + this.insuranceId
      })
    },
    async initPage() {
      SetLeChengShare()
    }
  }
}
</script>

<style lang="scss" scoped>
.stateP{
  color: #000;
  font-size: 3vw;
  line-height: 3vh;
  text-align: left;
}
.hiddens{
  display: none;
}
.ewmImg{
  width: calc(100% - 28px);
  display: block;
  position: absolute;
  bottom: 14px;
  left:14px;
  right:14px;
}
.h5Show{
  position: absolute;
  top:6vw;
  left:pxrem(28);
  right:pxrem(28);
    // font-size: 14px;
    // line-height: 26px;
}
.strongSpan{
  color: #FF282C;
  font-weight: bold;
}
.not_banner {
  width: 100%;
  display: block;
}
.centent_img {
  width: 90%;
  margin: 0 auto;
  color: #000;
  font-size: pxrem(28);
  // line-height: pxrem(40);
  position: relative;
  text-align: justify;
  b {
    display: contents;
  }
  .textp {
    position: absolute;
    top: 0;
    right: 5%;
    left: 36%;
    bottom: 0;
    margin: auto;
    display: flex;
    justify-content: center;
    flex-direction: column;
    color: #000;
    font-size: 4vw;
    line-height: 8vw;
    text-align: left;
  }
}
  /deep/.van-button{
    width: 80%;
    height: pxrem(96);
    position: absolute;
    left: 0;
    right: 0;
    margin: 20px auto;
    background: linear-gradient(135deg, #FF7828 0%, #FF282C 100%);
    border-radius: 45px;
    font-size: 16px;
    color: #FFF;
  }

.wxqrcode{
  position: absolute;
  bottom: 0.5vh;
  display: flex;
  font-size: 3vw;
  text-align: center;
  dd,p{
    margin: 0px;
  }
  p{
     padding-top: 10px;
  }
  img{
    width: 60%;
  }
  dt img{
    width: 64.4%;
  }
}




</style>
